import { CostsByTag } from "@interfaces/admin/costsByTag";
import { IOperatorIncome } from "@interfaces/admin/operatorIncome";
import { IOperatorModemsStat } from "@interfaces/admin/operatorModemsStat";
import { authApi } from "@RTKQuery/basic";

export const dashboardQueryOptions = {
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
};

const promoCodesAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getLiveStatistic: build.query<IOperatorModemsStat[], void>({
            query: () => "dashboard/actual_info",
            providesTags: ["ProxyAdmin"],
        }),
        getAllOperatorsIncome: build.query<IOperatorIncome[], {
            end_date: string,
            start_date: string
        }>({
            query: (params) => ({
                url: "dashboard/all_time",
                params: Object.assign(
                    params.start_date ? {
                        start_date: params.start_date
                    } : {},
                    params.end_date ? {
                        end_date: params.end_date
                    } : {},
                )
            }),
            providesTags: [{ type: "PurchaseHistoryAdmin", id: "ANALYTICS" }],
        }),
        getTotalIncome: build.query<{
            result_earn_usd: number,
            result_earn_ua: number,
            cost_usd: number,
            cost_ua: number,
            earn_usd: number,
            earn_ua: number
        }, {
            end_date: string,
            start_date: string
        }>({
            query: (params) => ({
                url: "dashboard/total_earn_cost",
                params: Object.assign(
                    params.start_date ? {
                        start_date: params.start_date
                    } : {},
                    params.end_date ? {
                        end_date: params.end_date
                    } : {},
                )
            }),
            providesTags: [{ type: "PurchaseHistoryAdmin", id: "ANALYTICS" }, "CostsAdmin"],
        }),
        getAllCostsByTags: build.query<CostsByTag[], {
            end_date: string,
            start_date: string
        }>({
            query: (params) => ({
                url: "dashboard/costs_statistic",
                params: Object.assign(
                    params.start_date ? {
                        start_date: params.start_date
                    } : {},
                    params.end_date ? {
                        end_date: params.end_date
                    } : {},
                )
            }),
            providesTags: ["CostsAdmin"],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetLiveStatisticQuery,
    useGetAllOperatorsIncomeQuery,
    useGetTotalIncomeQuery,
    useGetAllCostsByTagsQuery
} = promoCodesAuthApi;
